<template>
  <div id="contenedor-listado-desktop">
    <v-data-table :headers="headers" :items="listadoTiposObras" :items-per-page="20">
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :tipoObra="item"></opciones>
      </template>
      <template v-slot:[`item.color`]="{ item }">
        <v-avatar
        size="35"
        :color="item.color">
        </v-avatar>
      </template>
      <template v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano :fecha="new Date(item.createdAt)"></fecha-humano>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import Opciones from './Opciones.vue';
import FechaHumano from '@/components/FechaHumano.vue';

export default {
  name: 'ListadoTiposObrasDesktop',
  props: {
    listadoTiposObras: {
      type: Array,
      requited: true,
    },
  },
  components: {
    Opciones,
    FechaHumano,
  },
  data() {
    return {
      headers: [
        { text: '', width: 60, value: 'color' },
        {
          text: 'Descripción',
          align: 'start',
          value: 'descripcion',
        },
        { text: 'F. Registro', value: 'createdAt' },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss">

</style>
